import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { VendorModuleType } from '@/features/vendors/types';
import {
  fetch_agreement_overview,
  fetch_agreement_vendors,
  fetch_agreement_versions,
  publish_agreement,
} from './api';
import type { PublishAgreementInput } from './types';

const OVERVIEW_KEY = 'admin-agreement-overview';
const VERSIONS_KEY = 'admin-agreement-versions';
const VENDORS_KEY = 'admin-agreement-vendors';

export function use_agreement_overview() {
  return useQuery({
    queryKey: [OVERVIEW_KEY],
    queryFn: fetch_agreement_overview,
  });
}

export function use_agreement_versions(module_type: VendorModuleType | null) {
  return useQuery({
    queryKey: [VERSIONS_KEY, module_type],
    queryFn: () => fetch_agreement_versions(module_type as VendorModuleType),
    enabled: module_type !== null,
  });
}

export function use_agreement_vendors(agreement_id: string | null) {
  return useQuery({
    queryKey: [VENDORS_KEY, agreement_id],
    queryFn: () => fetch_agreement_vendors(agreement_id as string),
    enabled: agreement_id !== null,
  });
}

export function use_publish_agreement() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: PublishAgreementInput) => publish_agreement(input),
    onSuccess: (_data, input) => {
      void qc.invalidateQueries({ queryKey: [OVERVIEW_KEY] });
      void qc.invalidateQueries({ queryKey: [VERSIONS_KEY, input.module_type] });
    },
  });
}
